import React, { useRef } from "react";
import classNames from "classnames/bind";
import classes from "./SolutionsMenu.module.scss";
import { PanelMenu } from "primereact/panelmenu";
import { ISolutionsMenuItem } from "./MenuOptionsHelpers";
import { CSSTransition } from "react-transition-group";

interface Props {
  navExpanded: boolean;
  items: ISolutionsMenuItem[];
}

const SolutionsMenu: React.FC<Props> = ({ navExpanded, items }) => {
  const cx = classNames.bind(classes);
  const ref = useRef(null);

  return (
    <CSSTransition
      classNames="solutions-menu"
      nodeRef={ref}
      in={navExpanded}
      timeout={400}
      addEndListener={() => false}
    >
      <div className={cx(classes.solutionsMenuContainer)} ref={ref}>
        <PanelMenu model={items} />
      </div>
    </CSSTransition>
  );
};

export default SolutionsMenu;
